import environment from "environment";
import type { AxiosResponse } from "axios";
import { requestService } from "../request";
import type { Account, Payload } from "../../pages/EditAccount";

type GetAccountListResponse = {
  data: {
    accountsList: Array<Account>;
    count: number;
  };
};

export const getAccountList = (params?: Payload): Promise<AxiosResponse<GetAccountListResponse>> => requestService
  .get(environment.endpoints.get.accountList, { params });

export const getAccount = (accountId: string): Promise<AxiosResponse<{ data: { account: Account } }>> => requestService
  .get(environment.endpoints.get.account.replace("{id}", accountId));

export const createAccount = (data: Account): Promise<unknown> => {
  const transformedData = {
    ...data,
    users: data.users.map(({ name, ...rest }) => ({
      ...rest,
      username: name,
    })),
  };
  return requestService.post(environment.endpoints.post.account, transformedData);
};

export const updateAccount = (accountId: string, data: Account): Promise<unknown> => {
  const transformedData = {
    ...data,
    users: data.users.map(({ name, ...rest }) => ({
      ...rest,
      username: name,
    })),
  };
  return requestService.put(environment.endpoints.put.account.replace("{id}", accountId), transformedData);
};
